import { withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'
import type { BrowserWindow } from '@wix/thunderbolt-symbols'
import { ReactTemplateSymbol } from './symbols'
import type { ImportMap, ReactTemplate } from './types'
import * as signals from '@preact/signals-react'

function createModuleUrl(code: string) {
	const blob = new Blob([code], { type: 'text/javascript' })
	return URL.createObjectURL?.(blob) || ''
}

export const ImportMapFactory = withDependencies(
	[ReactTemplateSymbol, BrowserWindowSymbol],
	(reactTemplate: ReactTemplate, browserWindow: BrowserWindow): ImportMap => {
		let pendingImportMap: Record<string, string> = {
			react: createModuleUrl(reactTemplate.getReactModuleCode('window.React')),
			'react-dom': createModuleUrl(reactTemplate.getReactDOMModuleCode('window.ReactDOM')),
			'react/jsx-runtime': createModuleUrl(reactTemplate.getReactJsxRuntimeCode()),
			'react/jsx-dev-runtime': createModuleUrl(reactTemplate.getReactJsxDevRuntimeCode()),
			'@preact/signals-react': createModuleUrl(reactTemplate.getPreactSignalsReactModuleCode('window.signals')),
		}

		if (browserWindow) {
			;(browserWindow as any).signals = signals // TODO - https://wix.atlassian.net/browse/EDIX-31107
		}

		let commitId = 0
		const mapScriptId = 'builder-module-loader-importmap'

		const updateImportMap = (updates: Record<string, string>) => {
			if (Object.keys(updates).length === 0) {
				return
			}

			pendingImportMap = {
				...pendingImportMap,
				...updates,
			}
		}

		const commitImportMapUpdates = () => {
			if (!browserWindow?.document) {
				return
			}

			if (Object.keys(pendingImportMap).length === 0) {
				// nothing to commit
				return
			}

			const mapScript = browserWindow.document.createElement('script')
			mapScript.id = `${mapScriptId}-${commitId}`
			mapScript.type = 'importmap'
			browserWindow.document.head.appendChild(mapScript)
			mapScript.textContent = JSON.stringify({ imports: pendingImportMap })
			console.log('commited importmap', mapScript.id, pendingImportMap)
			pendingImportMap = {}
			commitId++
		}

		return {
			updateImportMap,
			commitImportMapUpdates,
			updateAndCommit: (dependencies) => {
				updateImportMap(dependencies)
				commitImportMapUpdates()
			},
		}
	}
)
